import type { Action } from '@reduxjs/toolkit';

import { API, getAsyncThunk } from 'app/api';

// ---

export const fetchHistoryStakes = getAsyncThunk(
  'MY_STAKES:FETCH_HISTORY_STAKES',
  API.myStakes.fetchHistoryStakes,
);

// ---

export const CLEANUP_HISTORY_STAKES = 'MY_STAKES:CLEANUP_HISTORY_STAKES';

export type CleanupHistoryStakes = Action<typeof CLEANUP_HISTORY_STAKES>;

export const cleanupHistoryStakes = (): CleanupHistoryStakes => ({ type: CLEANUP_HISTORY_STAKES });


